module.exports = __webpack_public_path__ + "static/media/user-active.5c62028c.svg";